import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';

export const LOGIN_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./login.component').then(m => m.LoginComponent),
  },
  {
    path: 'verify',
    title: 'Alphastar | OTP Verification',
    loadComponent: () =>
      import('./verification/verification.component').then(
        m => m.VerificationComponent
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(LOGIN_ROUTES)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
